export default {
    disease: 'بیماری خاص',
    diseaseTitleFa: 'عنوان فارسی',
    diseaseTitleEn: 'عنوان لاتین',
    diseaseStatus: 'وضعیت',
    diseases: 'مدیریت بیماری‌های خاص',
    editDisease: 'ویرایش بیماری خاص',
    addDisease: 'بیماری خاص جدید',
}